import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { type CategoryDisplayText } from '@/views/build/features/category-display-text';
import { type CategorySelectorState, PlainSelection } from '@/views/build/features/category-select-view';
export const SemesterSelection = ({
  categoryInfo,
  displayText
}: {
  categoryInfo: CategorySelectorState;
  displayText: CategoryDisplayText;
}) => {
  const {
    t
  } = useTranslation(['build', 'common']);
  const isSemesterSelectionEmpty = useMemo(() => {
    if (categoryInfo.grade.gradeNodes?.length === 0) return true;
    if (categoryInfo.semester.semesterNodes?.length === 0) return true;
    return false;
  }, [categoryInfo.grade.gradeNodes, categoryInfo.semester.semesterNodes]);
  const isSemesterSelectionActive = useMemo(() => {
    if (categoryInfo.semester.semesterNodes) return true;
    if (categoryInfo.grade.gradeNodes?.length === 0) return true;
    return false;
  }, [categoryInfo.semester.semesterNodes, categoryInfo.grade.gradeNodes]);
  return <PlainSelection label={t('common:school.info.semester')} value={categoryInfo.semester.selectedSemesterNode} isActive={isSemesterSelectionActive} isEmpty={isSemesterSelectionEmpty} options={categoryInfo.semester.semesterNodes ?? []} error={categoryInfo.errors.semesterId} onChange={categoryInfo.updateCategoryInfo} onHover={value => {
    displayText.updateHoverPreview({
      field: 'semesterId',
      value: value.nodeId,
      label: value.label
    });
  }} onHoverLeave={() => {
    displayText.clearHoverPreview('semesterId');
  }} data-sentry-element="PlainSelection" data-sentry-component="SemesterSelection" data-sentry-source-file="SemesterSelection.tsx" />;
};